module.exports = __webpack_public_path__ + "static/media/pennylane.d25c517d.png";